import { theme } from '@frontend/theme';
import { ColumnOutput } from '../utils';
import { Item } from './item';

type RowProps<T extends object> = {
  data: T;
  colConfig: ColumnOutput<T>[];
};

export const TableRow = <T extends object>({ data, colConfig }: RowProps<T>) => (
  <div
    css={{
      flexGrow: 1,
      display: 'grid',
      gridTemplateColumns: `auto auto`,
      gap: theme.spacing(1),
    }}
  >
    {colConfig.map((column, colIndex) => {
      // Get cell value using accessor or id
      let cellValue: string | number | React.ReactNode | T[keyof T];

      if (column.accessor) {
        if (typeof column.accessor === 'string') {
          cellValue = data[column.accessor as keyof T];
        } else if (typeof column.accessor === 'function') {
          if (typeof column.cellRenderer === 'function') {
            cellValue = column.cellRenderer(column.accessor(data) as T);
          } else {
            cellValue = column.accessor(data);
          }
        }
      }

      return <Item key={column.id || colIndex} label={column.Header} value={cellValue} />;
    })}
  </div>
);
